import React, { useState } from 'react';

export interface TreatmentContextProps {
	openMedicalReport: boolean;
	setOpenMedicalReport: (newState: boolean) => void;
	openMeddiDiabetes: boolean;
	setOpenMeddiDiabetes: (newState: boolean) => void;
	isTreatment: boolean;
	setIsTreatment: (newState: boolean) => void;
	isCase: boolean;
	setIsCase: (newState: boolean) => void;
	workplaceId: string;
}

export interface TreatmentContextProviderProps {
	values: TreatmentContextProps;
	children?: React.ReactChild | React.ReactChild[];
}

export const TreatmentContext = React.createContext({});
export const useTreatmentContext: () => TreatmentContextProps = () =>
	React.useContext<TreatmentContextProps>(TreatmentContext);

export function TreatmentContextProvider({
	values,
	children,
}: TreatmentContextProviderProps) {
	const [openMedicalReport, setOpenMedicalReport] = useState(
		values.openMedicalReport,
	);
	const [openMeddiDiabetes, setOpenMeddiDiabetes] = useState(
		values.openMeddiDiabetes,
	);
	const [isTreatment, setIsTreatment] = useState(values.isTreatment);
	const [isCase, setIsCase] = useState(values.isCase);
	const [userUpdated, setUserUpdated] = useState<number>(0);
	const handleUserUpdated = () => {
		setUserUpdated(+new Date());
	};
	return (
		<TreatmentContext.Provider
			value={{
				openMedicalReport,
				setOpenMedicalReport,
				openMeddiDiabetes,
				setOpenMeddiDiabetes,
				isTreatment,
				setIsTreatment,
				isCase,
				setIsCase,
				userUpdated,
				handleUserUpdated,
				workplaceId: values.workplaceId,
			}}>
			{children}
		</TreatmentContext.Provider>
	);
}
